import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ExtMetaConvConfigModel } from '@smarttask-common/src/lib/models/Integrations/Meta/Conv/ExtMetaConvConfigModel';

export enum MetaConvConfigActionTypes {
    ADD_META_CONV_CONFIG = '[MetaConvConfig] Create MetaConvConfig',
    ADD_META_CONV_CONFIGS = '[MetaConvConfig] Add MetaConvConfigs',
    UPSERT_META_CONV_CONFIG = '[MetaConvConfig] Upsert MetaConvConfig',
    UPSERT_META_CONV_CONFIGS = '[MetaConvConfig] Upsert MetaConvConfigs',
    UPDATE_META_CONV_CONFIG = '[MetaConvConfig] Update MetaConvConfig',
    UPDATE_META_CONV_CONFIGS = '[MetaConvConfig] Update MetaConvConfigs',
    DELETE_META_CONV_CONFIG = '[MetaConvConfig] Delete MetaConvConfig',
    DELETE_META_CONV_CONFIGS = '[MetaConvConfig] Delete MetaConvConfigs',
    DELETE_ALL_META_CONV_CONFIGS = '[MetaConvConfig] Delete All MetaConvConfigs',
    DELETE_ALL = '[MetaConvConfig] Delete All',

    UPDATE_SELECTED_ID = '[MetaConvConfig] Update SelectedId',
}

export class UpdateSelectedConfigId implements Action {
    readonly type = MetaConvConfigActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_config_id: number) {}
}

export class AddOne implements Action {
    readonly type = MetaConvConfigActionTypes.ADD_META_CONV_CONFIG;
    constructor(public config: ExtMetaConvConfigModel) {}
}

export class AddMany implements Action {
    readonly type = MetaConvConfigActionTypes.ADD_META_CONV_CONFIGS;
    constructor(public configs: Array<ExtMetaConvConfigModel>) {}
}

export class UpsertOne implements Action {
    readonly type = MetaConvConfigActionTypes.UPSERT_META_CONV_CONFIG;

    constructor(public config: ExtMetaConvConfigModel) {}
}

export class UpsertMany implements Action {
    readonly type = MetaConvConfigActionTypes.UPSERT_META_CONV_CONFIGS;
    constructor(public configs: Array<ExtMetaConvConfigModel>) {}
}

export class UpdateOne implements Action {
    readonly type = MetaConvConfigActionTypes.UPDATE_META_CONV_CONFIG;
    constructor(public config: Update<ExtMetaConvConfigModel>) {}
}

export class UpdateMany implements Action {
    readonly type = MetaConvConfigActionTypes.UPDATE_META_CONV_CONFIGS;
    constructor(public configs: Array<Update<ExtMetaConvConfigModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = MetaConvConfigActionTypes.DELETE_META_CONV_CONFIG;
    constructor(public config_id: number) {}
}

export class DeleteMany implements Action {
    readonly type = MetaConvConfigActionTypes.DELETE_META_CONV_CONFIGS;
    constructor(public config_ids: Array<number>) {}
}

export class DeleteAll implements Action {
    readonly type = MetaConvConfigActionTypes.DELETE_ALL_META_CONV_CONFIGS;
    constructor(public config_ids: Array<number>) {}
}

export class DeleteState implements Action {
    readonly type = MetaConvConfigActionTypes.DELETE_ALL;
    constructor() {}
}

export type MetaConvConfigActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedConfigId;
